module.exports = __webpack_public_path__ + "static/media/history-icon.4a40681c.svg";